<template>
  <van-popup v-model="getShow" class="popup" get-container="body" close-on-popstate>
    <div class="popup-container">
      <div class="content">
        <slot></slot>
      </div>
      <img class="close-img" @click="$emit('update:show',false)" src="@/assets/imgs/common/close-popup.png" alt="">
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "popupIndex",
  props:{
    show:{
      type:Boolean,
      default:false
    }
  },
  computed:{
    getShow:{
      set(value){
        this.$emit('update:show',value)
      },
      get(){
        return this.show
      }
    }
  }
}
</script>

<style scoped lang="scss">
.popup{
  background: none;
}
.popup-container{
  text-align: center;
  .close-img{
    padding-top: 30px;
    width: 24px;
    height: 24px;
  }
  .content{
    background: white;
    border-radius: 16px 16px 16px 16px;
    overflow: hidden;
    max-width: 295px;
  }
}
</style>
